import "./App.css";
import LandPartitionSystem from "./components/LandPartitionSystem";

function App() {
  return (
    <div className="App">
      <LandPartitionSystem />
    </div>
  );
}

export default App;
